export default __webpack_public_path__ + "static/media/powerreader_standard.8fb7c2b5.svg";